
export class RankingVO {
    public playerId: number = 0;
    public rank: number = 0;
    public name: string;
    public online: number = 0;
    public level: number = 0;
    public xp: number = NaN;
    public chips: number = NaN;
    public acPoints: number = 0;
}
